;(function (window) {
	var Self = window.mainNav = {}
	var $ = window.jQuery

	Self.$document = $(document)

  // jQuery('.menu-toggle').html('MENU');

	Self.$document.ready(function () {
    	init()
  	})
  	// private functions
  	function init () {

      Self.$menuItem = $('#site-desktop-navigation').find('.menu-item-has-children');
      Self.$menuItem.on('click',Self.toggleSubNavDesktop);
      Self.$currentOpen = null;

      Self.$menuMobileItem = $('#site-navigation').find('.menu-item-has-children');
      Self.$menuMobileItem.on('click',Self.toggleSubNavMobile);
      Self.$currentMobileOpen = null;

  	}

    Self.closeAllOpen = function(){
      $('.sub-menu').each(function(){
        if($(this).is(':visible')){
           $(this).animate({'width':'toggle','padding-left':'toggle','padding-right':'toggle'},200)
           $(this).find('li').animate({'opacity':"0"},200)
           $(this).parent().removeClass('menu-selected')
        }
      })
    }

    Self.toggleSubNavDesktop = function (){
      
      var submenu = $(this).find('.sub-menu')
      var isOpen = submenu.is(':visible')

      if(!submenu.is(':animated')){

        Self.closeAllOpen();
        
        if(!isOpen){
            submenu.animate({'width':'toggle','padding-left':'toggle','padding-right':'toggle'},340)
            submenu.find('li').delay(100).animate({'opacity':"1"},200)
            $(this).addClass('menu-selected');
        }
      }
    }

    Self.toggleSubNavMobile = function (){

      var submenu = $(this).find('.sub-menu')
      var $menu = $(this)

      $('.sub-menu').each(function(){

      if($(this)[0] != submenu[0]){
          $(this).removeClass('js-sub-opened')
          $(this).parent().removeClass('js-item-sub-opened')
        }
      })

      submenu.toggleClass('js-sub-opened')
      submenu.parent().toggleClass('js-item-sub-opened')

      
    }

})(window)